import { t as e } from "../../chunks/index.es.CfT5btWg.js";
import { jsx as t } from "react/jsx-runtime";
//#region lib/Factbox/components/FactboxBody.tsx
var n = ({ children: n, rootNode: r }) => {
	let i = e.isElement(r) && r?.properties?.editable === !1 ? !1 : void 0;
	return /* @__PURE__ */ t("div", {
		contentEditable: i !== !1 && void 0,
		className: "pt-2 font-sans text-slate-700 dark:text-slate-300",
		children: n
	});
};
//#endregion
export { n as FactboxBody };
